import React from 'react';
import CreateCertificationItemDraftDialog from './CreateCertificationItemDraftDialog';
import CreateCertificationItemDraftDialogService from '../services/CreateCertificationItemDraftDialogService';
import { observer } from 'mobx-react';

const CreateCertificationItemDraftDialogContainer = () =>
  !!CreateCertificationItemDraftDialogService.certificationTestCourseAbilityItem && (
    <CreateCertificationItemDraftDialog
      onSubmit={CreateCertificationItemDraftDialogService.handleSubmit}
      onChange={CreateCertificationItemDraftDialogService.form.setValue}
      onCancel={CreateCertificationItemDraftDialogService.handleClose}
      isOpen={CreateCertificationItemDraftDialogService.isOpen}
      values={CreateCertificationItemDraftDialogService.form.getValues()}
      errors={CreateCertificationItemDraftDialogService.form.errors}
      submitting={CreateCertificationItemDraftDialogService.submit.fetching}
      certificationTestCourseAbilityItem={CreateCertificationItemDraftDialogService.certificationTestCourseAbilityItem}
    />
  );

export default observer(CreateCertificationItemDraftDialogContainer);
